/**
 * The entity a Tiptap editor's uploads are attached to and resolved through:
 * regular editors attach files to their document, chat editors — to the chat.
 */
export type UploadScopeType = "document" | "chat";

export type UploadScope = {
  type: UploadScopeType;
  uid: string;
};

export const documentScope = (uid: string): UploadScope => ({ type: "document", uid });

export const chatScope = (uid: string): UploadScope => ({ type: "chat", uid });
